import { IWidgetState } from "../components/megawidget/megawidget-specialty/common/common-reducer";
import DateHelper from "./date-helper";

class ScrollbarHelper {
    static isVisible(state: IWidgetState, maxVisible: number): boolean {
        for (let sub of state.result.subResults) {
            if (DateHelper.areDatesEqual(sub.appointmentsDate, state.selectedDate) && sub.appointmentsCounter > maxVisible) {
                return true;
            }
        }
        return false;
    }
}

export default ScrollbarHelper;